import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase";
import { getAuth } from "firebase/auth";

/**
 * Fetches only the top-level folder metadata (folderId, folderName, status)
 * for the authenticated user from Firestore.
 * Returns an array of folder objects without subfolders or files.
 */
export async function fetchUserFolderMetadata() {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error("User not authenticated");
    }
    const userId = user.uid;

    // Fetch folders collection from Firestore under the user document
    const foldersSnapshot = await getDocs(
      collection(db, `users/${userId}/folders`)
    );
    const folders = [];

    for (const folderDoc of foldersSnapshot.docs) {
      const folderData = folderDoc.data();
      folders.push({
        folderId: folderDoc.id,
        folderName: folderData.folderName || "Unnamed Folder",
        status: folderData.status || "normal",
      });
    }

    return folders;
  } catch (error) {
    console.error("Error fetching user folder metadata:", error);
    return [];
  }
}
